import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  selectExcludePersonalEvents,
  selectShowFromAllLocations,
  setExcludePersonalEvents,
  setShowFromAllLocations,
} from "features/scheduling/scheduler-slice";
import * as React from "react";
import { selectNumberOfPracticeClinics } from "features/auth/auth-slice";

export default function StaffAvailabilitySettings() {
  const dispatch = useAppDispatch();
  const excludePersonalEvents = useAppSelector(selectExcludePersonalEvents);
  const showFromAllLocations = useAppSelector(selectShowFromAllLocations);
  const numberOfPracticeClinics =
    useAppSelector(selectNumberOfPracticeClinics) || 0;
  const multiClinic = numberOfPracticeClinics > 1;
  return (
    <Stack direction="row" spacing={1}>
      {multiClinic && (
        <FormControlLabel
          control={
            <Switch
              checked={showFromAllLocations}
              onChange={() => {
                dispatch(setShowFromAllLocations(!showFromAllLocations));
              }}
            />
          }
          label="Show from all locations"
          sx={{ m: 1, pt: 3 }}
        />
      )}
      <FormControlLabel
        control={
          <Switch
            checked={excludePersonalEvents}
            onChange={() => {
              dispatch(setExcludePersonalEvents(!excludePersonalEvents));
            }}
          />
        }
        label="Exclude Staff member's personal events"
        sx={{ m: 1, pt: 3 }}
      />
    </Stack>
  );
}
